import React, { useEffect, useState } from 'react';
import { Editor, EditorState, RichUtils, convertToRaw, convertFromRaw, Modifier, SelectionState, AtomicBlockUtils } from 'draft-js';
import 'draft-js/dist/Draft.css';
import { OrderedSet } from 'immutable';
import { Container, Row, Col } from 'react-bootstrap';
import MyAtomicComponent from './MyAtomicComponent';
import Web from './web/Web';
import Calendar from './Calendar';

const styleMap = {
	'YELLOW': {
		background: 'YELLOW'
	},
	'LINK': {
		background: 'LIGHTGREEN'
	}
}

export function MyEditor({ selectedPage, tree, existingPageData, savePage, saveChange, addBlankPage, deletePage, setIsMoving }) {
	const convertRawToComments = (rawComments) => {
		if (rawComments !== undefined) {
			let comments = { ...rawComments }

			for (let commentKey in rawComments) {
				console.log(commentKey)
				console.log(JSON.stringify(comments[commentKey].comment))
				try {
					comments[commentKey].comment = EditorState.createWithContent(convertFromRaw(comments[commentKey].comment))
				} catch (e) {
					console.log("comment error")
					console.log(e)
				}
			}
			return comments
		}
		return {}
	}

	const convertCommentsToRaw = () => {
		let rawComments = { ...pageData.comments }
		for (let commentKey in pageData.comments) {
			rawComments[commentKey].comment = convertToRaw(rawComments[commentKey].comment.getCurrentContent())
		}

		return rawComments
	}
	const [expandedComments, setExpandedComments] = useState(true)
	const [isLatestSaved, setIsLatestSaved] = useState(true)
	let [pageData, setPageData] = useState({
		...existingPageData,
		editorState: (existingPageData === undefined || existingPageData.editorState === undefined) ? EditorState.createEmpty() : EditorState.createWithContent(convertFromRaw(existingPageData.editorState)),
		comments: convertRawToComments(existingPageData?.comments)
	})
	const [newComment, setNewComment] = useState({ editorState: EditorState.createEmpty() })
	const [selectedComment, setSelectedComment] = useState(undefined)
	const [editingWidget, setEditingWidget] = useState(null)

	useEffect(() => {
		setPageData({
			...existingPageData,
			editorState: (existingPageData === undefined || existingPageData.editorState === undefined) ? EditorState.createEmpty() : EditorState.createWithContent(convertFromRaw(existingPageData.editorState))
		})
		setSelectedComment(undefined)
	}, [existingPageData])



	const handleKeyCommand = (command, editorState) => {

		console.log("Hanlde Key Command")
		console.log(command)

		const newState = RichUtils.handleKeyCommand(editorState, command);

		if (newState) {
			handleChange(newState);
			return 'handled';
		}

		return 'not-handled';
	}

	const saveChanges = (editorState) => {
		const contentState = editorState.getCurrentContent();
		const selectionState = editorState.getSelection();

		const startKey = selectionState.getStartKey();
		const endKey = selectionState.getEndKey();
		const blockMap = contentState.getBlockMap();

		// 1. Identify all blocks within the current selection range
		const selectedBlocks = blockMap
			.toSeq()
			.skipUntil((v, k) => k === startKey)
			.takeUntil((v, k) => k === endKey)
			.concat([[endKey, blockMap.get(endKey)]]);

		// 2. Build the "Bulk Update" object
		const updates = {};
		const timestamp = Date.now();

		selectedBlocks.forEach((block, key) => {
			// We create a relative path for each block key
			const path = `${key}`;
			updates[path] = {
				text: block.getText(),
				type: block.getType(),
				data: block.getData().toJS(),
				lastUpdated: timestamp
			};
		});

		saveChange(updates)

	};

	const handleChange = (editorState) => {
		const prevContent = pageData.editorState.getCurrentContent();
		const nextContent = editorState.getCurrentContent();

		const prevText = prevContent.getPlainText();
		const nextText = nextContent.getPlainText();

		const [textAdded, textRemoved] = getChangedText(prevText, nextText)

		//check start link
		let lastLength = pageData.editorState.getCurrentContent().getPlainText().length;
		let newLength = editorState.getCurrentContent().getPlainText().length
		let newData = {}
		let newChar = getLastCharacter(editorState)

		let handledEditorState = editorState;

		//Text changed
		const hasContentChanged = editorState.getCurrentContent() !== pageData.editorState.getCurrentContent();

		if (hasContentChanged) {
			setIsLatestSaved(false)

			saveChanges(editorState)

			if (newLength === lastLength + 1) {
				let selection = pageData.editorState.getSelection()
				let blockArray = editorState.getCurrentContent().getBlockMap().keySeq().toArray()
				console.log(blockArray)
				let newCharKeyIndex = blockArray.indexOf(selection.getStartKey())
				let newCharOffset = selection.getEndOffset()
				console.log(blockArray.indexOf(selection.getStartKey()))
				let newComments = { ...pageData.comments }
				console.log(newChar)
				for (let commentKey in pageData.comments) {
					let comment = pageData.comments[commentKey]
					let commentStartKeyIndex = blockArray.indexOf(comment.startKey)
					let commentEndKeyIndex = blockArray.indexOf(comment.endKey)
					console.log(comment)
					console.log(commentStartKeyIndex)

					if (commentStartKeyIndex === newCharKeyIndex) {
						if (comment.startOffset >= newCharOffset) {
							newComments[commentKey].startOffset++
						}
					}

					if (commentEndKeyIndex === newCharKeyIndex) {
						if (comment.endOffset > newCharOffset) {
							newComments[commentKey].endOffset++
						}
					}
				}
				newData.comments = newComments
			}
		} else {

			//selection changed
			const selection = editorState.getSelection();
			if (selection.isCollapsed()) {
				const currentContent = editorState.getCurrentContent();
				const startKey = selection.getStartKey();
				const startOffset = selection.getStartOffset();
				const block = currentContent.getBlockForKey(startKey);

				let beforeStyle = block.getInlineStyleAt(startOffset - 1)
				let afterStyle = block.getInlineStyleAt(startOffset)
				for (let style of ['YELLOW', 'LINK']) {
					let beforeHas = beforeStyle.has(style)
					let afterHas = afterStyle.has(style)
					let currentHas = editorState.getCurrentInlineStyle().has(style)

					if (beforeHas && currentHas && !afterHas) {
						handledEditorState = RichUtils.toggleInlineStyle(editorState, style)
					}
				}
			}
		}

		console.log("Handle change")
		console.log(editorState)
		const contentState = editorState.getCurrentContent();
		const rawContentState = convertToRaw(contentState);
		// console.log(JSON.stringify(rawContentState));

		let newPageData = { ...pageData, editorState: handledEditorState, ...newData }
		if (textAdded.includes("\n") || textRemoved.includes("#")) {
			newPageData.linkStart = undefined
		}
		console.log(newPageData)

		setPageData(newPageData)
	}

	const getChangedText = (oldText, newText) => {

		let textAdded = "";
		let textRemoved = "";

		if (newText !== oldText) {
			// 1. Find where the strings diverge from the start
			let start = 0;
			while (start < oldText.length && start < newText.length && oldText[start] === newText[start]) {
				start++;
			}

			// 2. Find where they diverge from the end
			let endPrev = oldText.length - 1;
			let endNext = newText.length - 1;
			while (endPrev >= start && endNext >= start && oldText[endPrev] === newText[endNext]) {
				endPrev--;
				endNext--;
			}

			// 3. Extract the differences
			textRemoved = oldText.slice(start, endPrev + 1);
			textAdded = newText.slice(start, endNext + 1);
		}

		return [textAdded, textRemoved]
	};

	const handleChangeNewComment = (editorState) => {

		let handledEditorState = editorState;

		setNewComment({ ...newComment, editorState: handledEditorState })

	}

	const handleChangeComment = (editorState, commentKey) => {

		let handledEditorState = editorState;
		let newComments = { ...pageData.comments }
		console.log("change comment")
		console.log(JSON.stringify(newComments))
		newComments[commentKey].comment = handledEditorState

		setPageData({ ...pageData, comments: newComments })

	}

	const handleBeforeInput = (chars, editorState, eventTimeStamp) => {
		console.log("handleBeforeInput")
		console.log(chars)
		logSelection(pageData.editorState.getSelection())
		logSelection(editorState.getSelection())

		//check start link
		let newData = {}

		let currentSelection = editorState.getSelection()
		const selection = editorState.getSelection();
		const contentState = editorState.getCurrentContent();
		const blockKey = selection.getStartKey();
		const block = contentState.getBlockForKey(blockKey);

		if (block.getType() === 'atomic') {
			return 'handled'; // Prevent Draft.js from processing input
		}


		let blockArray = editorState.getCurrentContent().getBlockMap().keySeq().toArray()
		console.log(blockArray)

		if (chars === "#") {
			console.log(pageData.linkStart)
			if (pageData.linkStart === undefined) {
				console.log("#Hashtag: " + JSON.stringify(currentSelection.entries))
				newData.linkStart = currentSelection
				let newEditorState = EditorState.push(editorState,
					Modifier.insertText(
						editorState.getCurrentContent(),
						currentSelection,
						"#"),
					"insert-characters")
				setPageData({ ...pageData, editorState: newEditorState, ...newData })
			} else {
				let name = pageData.editorState.getCurrentContent().getBlockForKey(pageData.linkStart.getAnchorKey()).getText()
				name = name.substring(pageData.linkStart.getAnchorOffset() + 1, pageData.editorState.getSelection().getFocusOffset())
				addBlankPage(name, undefined, (id) => {
					selectLink(id, name)
				})
				console.log("New page name")
				console.log(name)

			}
			return "handled"
		}
	}

	const handleBeforeInputNewComment = (chars, editorState, eventTimeStamp) => {
		console.log("handleBeforeInput")
		console.log(chars)
		logSelection(newComment.editorState.getSelection())
		logSelection(editorState.getSelection())

		//check start link
		let newData = {}

		let currentSelection = editorState.getSelection()
		let blockArray = editorState.getCurrentContent().getBlockMap().keySeq().toArray()
		console.log(blockArray)

		if (chars === "#") {
			console.log(newComment.linkStart)
			if (newComment.linkStart === undefined) {
				console.log("#Hashtag: " + JSON.stringify(currentSelection.entries))
				newData.linkStart = currentSelection
				let newEditorState = EditorState.push(editorState,
					Modifier.insertText(
						editorState.getCurrentContent(),
						currentSelection,
						"#"),
					"insert-characters")
				setNewComment({ ...newComment, editorState: newEditorState, ...newData })
			} else {
				let name = newComment.editorState.getCurrentContent().getBlockForKey(newComment.linkStart.getAnchorKey()).getText()
				name = name.substring(newComment.linkStart.getAnchorOffset() + 1, newComment.editorState.getSelection().getFocusOffset())
				addBlankPage(name, undefined, (id) => {
					selectLink(id, name)
				})
				console.log("New page name")
				console.log(name)

			}
			return "handled"
		}
	}

	const handlePastedText = (text, html, editorState) => {
		console.log("handlePastedText")
		console.log(text)
		console.log(html)
		logSelection(pageData.editorState.getSelection())
		logSelection(editorState.getSelection())
	}

	const getLinkOptions = () => {
		let selection = pageData.editorState.getSelection()
		let end = selection.getAnchorOffset()
		let filterString = pageData.editorState.getCurrentContent().getBlockForKey(selection.getAnchorKey()).getText().substring(pageData.linkStart.getAnchorOffset() + 1, selection.getAnchorOffset())

		let options = addOptions(tree.pages, filterString)

		let regex = new RegExp(filterString, "i")
		options = options.filter(o => regex.test(o.name))

		return <div className='reference-options'>{options.map(o => {
			return <button key={o.id} onClick={() => selectLink(o.id, o.name)}>{o.name}</button>
		})}</div>
	}

	const addOptions = (pages, filter) => {
		let regex = new RegExp(filter, "i")
		let options = []
		console.log(pages)
		for (let pageId in pages) {
			let page = pages[pageId]
			if (regex.test(page.name)) {
				options.push({ name: page.name, id: page.id })
			}

		}
		console.log(options)
		options.sort((a, b) => a.name.localeCompare(b.name))
		options.sort((a, b) => b.name.toLowerCase().startsWith(filter) - a.name.toLowerCase().startsWith(filter))
		return options.slice(0, 5)
	}

	const selectLink = (id, name) => {
		let blockKey = pageData.linkStart.getAnchorKey()
		let selection = SelectionState.createEmpty(blockKey)
		selection = selection.merge({
			anchorOffset: pageData.linkStart.getAnchorOffset(),
			focusOffset: pageData.editorState.getSelection().getFocusOffset()
		})
		let contentStateWithEntity = pageData.editorState.getCurrentContent().createEntity("LINK", "Immutable", { id: id })
		let entityKey = contentStateWithEntity.getLastCreatedEntityKey()
		let text = "#" + name + "#"
		let contentStateWithLink = Modifier.replaceText(
			contentStateWithEntity,
			selection,
			text,
			OrderedSet.of('LINK'), entityKey)

		let selectionAfterLink = SelectionState.createEmpty(selection.getAnchorKey())
		selectionAfterLink = selectionAfterLink.merge({
			anchorOffset: selection.getAnchorOffset() + text.length,
			focusOffset: selection.getAnchorOffset() + text.length
		})

		let linkData;
		if (pageData.references === undefined) {
			linkData = {}
			linkData[blockKey] = {}
			linkData[blockKey][id] = true
		} else {
			linkData = { ...pageData.references }
			if (linkData[blockKey] === undefined) {
				linkData[blockKey] = {}
				linkData[blockKey][id] = true
			} else {
				linkData[blockKey][id] = true
			}
		}

		let updatedReferences = pageData.updatedReferences
		if (updatedReferences === undefined) {
			updatedReferences = new Set()
		}
		updatedReferences.add(blockKey + "/" + id)


		setPageData({
			...pageData,
			editorState: RichUtils.toggleInlineStyle(EditorState.forceSelection(
				EditorState.set(
					pageData.editorState,
					{ currentContent: contentStateWithLink }
				),
				selectionAfterLink
			), "LINK"), linkStart: undefined,
			references: linkData,
			updatedReferences: updatedReferences
		})
	}

	const createComment = () => {
		console.log("create comment")
		let selection = pageData.editorState.getSelection()

		if (selection.isCollapsed()) {
			return
		}

		let commentId;
		if (pageData.maxComment === undefined) {
			commentId = 0;
		} else {
			commentId = pageData.maxComment + 1
		}
		let newComments = {}
		if (pageData.comments !== undefined) {
			newComments = { ...pageData.comments }
		}
		newComments[commentId] = {
			startKey: selection.getStartKey(),
			startOffset: selection.getStartOffset(),
			endKey: selection.getEndKey(),
			endOffset: selection.getEndOffset(),
			comment: newComment.editorState
		}

		setPageData({
			...pageData, maxComment: commentId, comments: newComments,
			editorState: EditorState.push(
				pageData.editorState,
				Modifier.applyInlineStyle(
					pageData.editorState.getCurrentContent(),
					selection,
					'YELLOW'),
				"change-inline-style")
		})
		setNewComment({ editorState: EditorState.createEmpty() })
	}

	const getLastCharacter = (editorState) => {
		let selection = editorState.getSelection()
		let offset = selection.getEndOffset()
		return editorState.getCurrentContent().getBlockForKey(selection.getAnchorKey()).getText().slice(offset - 1, offset)
	}

	const save = async (e) => {
		e.preventDefault()
		let data = { ...pageData, editorState: convertToRaw(pageData.editorState.getCurrentContent()), comments: convertCommentsToRaw() }
		delete data.linkStart
		let updatedReferences = []
		let blockTexts = {}
		console.log("Save")
		console.log(data)
		console.log(pageData.updatedReferences)
		try {
			pageData.updatedReferences.forEach((reference) => {
				let [block, id] = reference.split("/")
				let referenceData = {}
				referenceData.block = block
				referenceData.id = id
				if (blockTexts[block] === undefined) {
					let text = pageData.editorState.getCurrentContent().getBlockForKey(block).getText()
					blockTexts[block] = text
					referenceData.text = text
				} else {
					referenceData.text = blockTexts[block]
				}
				updatedReferences.push(referenceData)
				console.log(updatedReferences)
			})
		} catch (e) {
			console.log("No references")
			console.log(e)
		}
		delete data.updatedReferences
		savePage(data, updatedReferences)
		data.editorState = { ...pageData.editorState }
		console.log("new editor state")
		console.log(data)
		let newPageData = { ...pageData }
		delete newPageData.linkStart
		delete newPageData.updatedReferences
		setPageData(newPageData)
		setIsLatestSaved(true)
	}

	const onClickDelete = async () => {
		//TODO add confirmation
		//TODO add choice for delete sub folders or reparenting 

		deletePage(selectedPage.id)
	}

	const onClickMove = async () => {
		setIsMoving(value => {
			console.log("Is moving before: ", value)
			console.log("Is moving after: ", !value)
			return !value
		})
	}

	const onClickAddWeb = async () => {
		let data = JSON.parse('{"nodes":[{"id":"mdez6y1pvlb","name":"Mastercard","type":"field"},{"id":"mdez7axlfjf","name":"Salary","type":"field"},{"id":"mdez7udkodk","name":"HSA","type":"field"},{"id":"mdez81c58n7","name":"401K","type":"field"},{"id":"mdezcs0udk7","name":"Post-Tax Salary","type":"field"},{"id":"mdezh7ehs3z","name":"Dental","type":"field"},{"id":"mdezjiehbrn","name":"Vison","type":"field"},{"id":"mdezki5d7yl","name":"Legal","type":"field"},{"id":"mdezlwnggzd","name":"Social Security","type":"field"},{"id":"mdezm1sjg5k","name":"Medicare","type":"field"},{"id":"mdezm6nas9r","name":"Federal Tax","type":"field"},{"id":"mdezncuyejx","name":"State Tax","type":"field"},{"id":"mdf13zrpozv","name":"Checking","type":"field"},{"id":"j81mdgt74vr","name":"529","type":"field"},{"id":"4wzmdgt7mhj","name":"Edward Jones","type":"field"},{"id":"19dmdgt800v","name":"IRA Tim","type":"field"},{"id":"1admdgt846v","name":"IRA Jennifer","type":"field"},{"id":"8femdgt8iab","name":"IRA Jennifer (Trad)","type":"field"},{"id":"2q3mdgt8vqp","name":"Investing","type":"field"},{"id":"a0cmdgt96u3","name":"Money Market","type":"field"},{"id":"39dmdgtdk1r","name":"Mortgage","type":"field"},{"id":"uvamdgtdwih","name":"Groceries","type":"field"},{"id":"c1smdgtedli","name":"Donations","type":"field"},{"id":"7pmmdgtei2q","name":"CTK","type":"field"},{"id":"4j4mdgtelhh","name":"Nick","type":"field"},{"id":"3ajmdgtesdr","name":"Wurth","type":"field"},{"id":"xphmdgtezv5","name":"Kaitlin","type":"field"},{"id":"s9omdgtf8eu","name":"Ryan","type":"field"},{"id":"mpamdgtfruw","name":"Utilities","type":"field"},{"id":"28amdgtg1bq","name":"Ameren","type":"field"},{"id":"d3vmdgtg4o5","name":"Spire","type":"field"},{"id":"clkmdgtg9si","name":"MAW","type":"field"},{"id":"15zmdgtgdfc","name":"MSD","type":"field"},{"id":"6l3mdgtgim0","name":"Solid Waste","type":"field"},{"id":"i97mdgu3kd8","name":"Newman","type":"field"},{"id":"jgzmdgu8cnk","name":"Spectrum","type":"field"},{"id":"sx9mdgu8jh0","name":"ATT","type":"field"},{"id":"b35mdgu8tgc","name":"Services","type":"field"},{"id":"whzmdgu8w7i","name":"IFTTT","type":"field"},{"id":"49rmdgu8zcm","name":"TempDrop","type":"field"},{"id":"1ormdgu92tm","name":"Hawx","type":"field"},{"id":"wv5mdgu99xi","name":"YourVillage","type":"field"},{"id":"658mdgu9hth","name":"Google Nest","type":"field"},{"id":"w1vmdgu9pjz","name":"Google Drive","type":"field"},{"id":"lx4mdgunioc","name":"Prime","type":"field"}],"connections":[{"from":"mdez6y1pvlb","to":"mdez7axlfjf","name":"8565"},{"from":"mdez7axlfjf","to":"mdezh7ehs3z","name":"62"},{"from":"mdez7axlfjf","to":"mdez7udkodk","name":"712"},{"from":"mdez7axlfjf","to":"mdezjiehbrn","name":"14"},{"from":"mdez7axlfjf","to":"mdezcs0udk7","name":"7776"},{"from":"mdezcs0udk7","to":"mdez81c58n7","name":"685"},{"from":"mdezcs0udk7","to":"mdezki5d7yl","name":"21"},{"from":"mdezcs0udk7","to":"mdezlwnggzd","name":"486"},{"from":"mdezcs0udk7","to":"mdezm1sjg5k","name":"113"},{"from":"mdezcs0udk7","to":"mdezm6nas9r","name":"849"},{"from":"mdezcs0udk7","to":"mdezncuyejx","name":"292"},{"from":"mdezcs0udk7","to":"mdf13zrpozv","name":"5333"},{"from":"mdez6y1pvlb","to":"mdez7udkodk","name":"42"},{"from":"mdez6y1pvlb","to":"mdez81c58n7","name":"857"},{"from":"mdf13zrpozv","to":"j81mdgt74vr","name":"300"},{"from":"mdf13zrpozv","to":"4wzmdgt7mhj","name":"500"},{"from":"4wzmdgt7mhj","to":"19dmdgt800v","name":""},{"from":"4wzmdgt7mhj","to":"1admdgt846v","name":""},{"from":"4wzmdgt7mhj","to":"8femdgt8iab","name":""},{"from":"4wzmdgt7mhj","to":"2q3mdgt8vqp","name":""},{"from":"4wzmdgt7mhj","to":"a0cmdgt96u3","name":""},{"from":"mdf13zrpozv","to":"39dmdgtdk1r","name":"1805"},{"from":"mdf13zrpozv","to":"c1smdgtedli","name":"946"},{"from":"c1smdgtedli","to":"7pmmdgtei2q","name":"450"},{"from":"c1smdgtedli","to":"4j4mdgtelhh","name":"75"},{"from":"c1smdgtedli","to":"3ajmdgtesdr","name":"75"},{"from":"c1smdgtedli","to":"xphmdgtezv5","name":"85"},{"from":"c1smdgtedli","to":"s9omdgtf8eu","name":"35"},{"from":"c1smdgtedli","to":"i97mdgu3kd8","name":"50"},{"from":"mpamdgtfruw","to":"15zmdgtgdfc","name":"61"},{"from":"mpamdgtfruw","to":"28amdgtg1bq","name":"104"},{"from":"mpamdgtfruw","to":"d3vmdgtg4o5","name":"140"},{"from":"mpamdgtfruw","to":"clkmdgtg9si","name":"50"},{"from":"b35mdgu8tgc","to":"wv5mdgu99xi","name":"7"},{"from":"b35mdgu8tgc","to":"1ormdgu92tm","name":"83"},{"from":"b35mdgu8tgc","to":"658mdgu9hth","name":"13"},{"from":"b35mdgu8tgc","to":"whzmdgu8w7i","name":"4"},{"from":"mpamdgtfruw","to":"jgzmdgu8cnk","name":"65"},{"from":"mpamdgtfruw","to":"6l3mdgtgim0","name":"20"},{"from":"b35mdgu8tgc","to":"w1vmdgu9pjz","name":"8"},{"from":"b35mdgu8tgc","to":"49rmdgu8zcm","name":"3"},{"from":"mdf13zrpozv","to":"mpamdgtfruw","name":"440"},{"from":"mpamdgtfruw","to":"sx9mdgu8jh0","name":"0"},{"from":"b35mdgu8tgc","to":"lx4mdgunioc","name":"12"},{"to":"b35mdgu8tgc","from":"mdf13zrpozv","name":"130"}]}')
		let locationData = JSON.parse('{"nodes":[{"id":"mdez6y1pvlb","x":66,"y":41},{"id":"mdez7axlfjf","x":199,"y":167},{"id":"mdez7udkodk","x":306,"y":90},{"id":"mdez81c58n7","x":428,"y":39},{"id":"mdezcs0udk7","x":430,"y":172},{"id":"mdezh7ehs3z","x":134,"y":288},{"id":"mdezjiehbrn","x":208,"y":287},{"id":"mdezki5d7yl","x":273,"y":291},{"id":"mdezlwnggzd","x":140,"y":582},{"id":"mdezm1sjg5k","x":227,"y":576},{"id":"mdezm6nas9r","x":294,"y":550},{"id":"mdezncuyejx","x":358,"y":521},{"id":"mdf13zrpozv","x":691,"y":175},{"id":"j81mdgt74vr","x":559,"y":43},{"id":"4wzmdgt7mhj","x":670,"y":64},{"id":"19dmdgt800v","x":646,"y":24},{"id":"1admdgt846v","x":728,"y":21},{"id":"8femdgt8iab","x":818,"y":37},{"id":"2q3mdgt8vqp","x":817,"y":72},{"id":"a0cmdgt96u3","x":819,"y":103},{"id":"39dmdgtdk1r","x":848,"y":171},{"id":"uvamdgtdwih","x":846,"y":227},{"id":"c1smdgtedli","x":816,"y":332},{"id":"7pmmdgtei2q","x":942,"y":289},{"id":"4j4mdgtelhh","x":948,"y":437},{"id":"3ajmdgtesdr","x":953,"y":388},{"id":"xphmdgtezv5","x":953,"y":341},{"id":"s9omdgtf8eu","x":916,"y":526},{"id":"mpamdgtfruw","x":533,"y":264},{"id":"28amdgtg1bq","x":472,"y":221},{"id":"d3vmdgtg4o5","x":436,"y":273},{"id":"clkmdgtg9si","x":453,"y":327},{"id":"15zmdgtgdfc","x":599,"y":329},{"id":"6l3mdgtgim0","x":543,"y":204},{"id":"i97mdgu3kd8","x":935,"y":481},{"id":"75qmdgu3trb","x":820,"y":288},{"id":"jgzmdgu8cnk","x":533,"y":349},{"id":"sx9mdgu8jh0","x":482,"y":374},{"id":"b35mdgu8tgc","x":698,"y":476},{"id":"whzmdgu8w7i","x":682,"y":577},{"id":"49rmdgu8zcm","x":760,"y":570},{"id":"1ormdgu92tm","x":607,"y":403},{"id":"wv5mdgu99xi","x":608,"y":572},{"id":"658mdgu9hth","x":560,"y":437},{"id":"w1vmdgu9pjz","x":541,"y":534},{"id":"lx4mdgunioc","x":527,"y":479}]}')
		const contentState = pageData.editorState.getCurrentContent();
		const contentStateWithEntity = contentState.createEntity(
			'CUSTOM_OBJECT',
			'IMMUTABLE',
			{} // your diagram config, metadata, etc.
		);
		const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
		const newEditorState = AtomicBlockUtils.insertAtomicBlock(pageData.editorState, entityKey, ' ');

		handleChange(newEditorState)

		console.log("onCLickAddWeb: " + { data: data, locationData: locationData })
		// setEditingWidget({key:entityKey, data:{data: data, locationData: locationData}})
		setEditingWidget({ key: entityKey, data: {} })
	}

	const onClickAddCalendar = async () => {
		const contentState = pageData.editorState.getCurrentContent();
		const contentStateWithEntity = contentState.createEntity(
			'CUSTOM_OBJECT',
			'IMMUTABLE',
			{ type: "calendar" } // your diagram config, metadata, etc.
		);
		const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
		const newEditorState = AtomicBlockUtils.insertAtomicBlock(pageData.editorState, entityKey, ' ');

		handleChange(newEditorState)

		console.log("onClickAddCalendar: ")
		setEditingWidget({ key: entityKey, data: { type: "calendar" } })
	}


	const logSelection = (selection) => {
		console.log(selection.getStartKey() + " : " +
			selection.getStartOffset() + " : " +
			selection.getEndKey() + " : " +
			selection.getEndOffset())
	}

	function myBlockRenderer(contentBlock) {
		if (contentBlock.getType() === 'atomic') {
			return {
				component: MyAtomicComponent,
				editable: false,
				props: {
					editWidget: editWidget
					// pass any props needed for rendering
				},
			};
		}
		return null;
	}

	const updateWidget = (data) => {
		const entityKey = editingWidget.key
		const contentState = pageData.editorState.getCurrentContent()

		console.log("Update widget: " + entityKey + " ; " + JSON.stringify(data))

		const newContentState = contentState.replaceEntityData(entityKey, data);

		// Push the new content state into the editor
		const newEditorState = EditorState.push(pageData.editorState, newContentState, 'apply-entity');
		console.log("Update widget")
		console.log(JSON.stringify(newEditorState))
		// ✅ Re-fetch the entity from the new content state
		const updatedEntity = newEditorState.getCurrentContent().getEntity(entityKey);
		console.log("Updated entity data:", updatedEntity.getData());

		handleChange(newEditorState)

	}

	const editWidget = (entityKey, data) => {
		console.log("EDIT WIDGET")
		setEditingWidget({ key: entityKey, data: data })
	}

	const renderWidget = () => {
		console.log("Render")
		console.log(editingWidget.data.type)
		switch (editingWidget.data.type) {
			case "calendar":
				return <Calendar initialData={editingWidget.data} update={updateWidget} exit={() => setEditingWidget(null)} editing={true} />
			default:
				return <Web initialData={editingWidget.data} update={updateWidget} exit={() => setEditingWidget(null)} editing={true} />
		}
	}

	return (
		<div className='page'>
			<div className='page-header'>
				<div className='page-header-left'>
					<button onClick={onClickDelete}>Delete</button>
					<button onClick={onClickMove}>Move</button>
					<button onClick={onClickAddWeb}>Add Web</button>
					<button onClick={onClickAddCalendar}>Add Calendar</button>
				</div>
				<div className='page-header-right'>
					<button onMouseDown={save}>{isLatestSaved ? "Saved!" : "Save"}</button>
					{expandedComments ? null : <button onClick={() => setExpandedComments(true)}>{"<"}</button>}
				</div>
			</div>
			<div className='page-content-container'>
				<div className={`content-layout ${expandedComments ? 'show-sidebar' : ''}`}>
					<div className='main-column'>
						<div className='page-text'>
							<span className='name'>{pageData.name}</span>
							{editingWidget !== null ? renderWidget() : (
								<Editor
									customStyleMap={styleMap}
									editorState={pageData.editorState}
									handleKeyCommand={handleKeyCommand}
									onChange={handleChange}
									handleBeforeInput={handleBeforeInput}
									handlePastedText={handlePastedText}
									blockRendererFn={myBlockRenderer}
								/>
							)}
							<br />
						</div>
					</div>

					{expandedComments && (
						<div className='comments-sidebar'>
							<div className='comments'>
								<h3>
									<button onClick={() => setExpandedComments(false)}>{">"}</button>
									Comments
								</h3>
								<br />
								{pageData.comments && Object.keys(pageData.comments).map((key) => (
									<div key={key} className='comment'>
										<Editor
											customStyleMap={styleMap}
											editorState={pageData.comments[key].comment}
											onChange={(editorState) => handleChangeComment(editorState, key)}
										/>
									</div>
								))}

								{!pageData.editorState.getSelection().isCollapsed() && (
									<div className='comment'>
										<Editor
											customStyleMap={styleMap}
											editorState={newComment.editorState}
											handleKeyCommand={handleKeyCommand}
											onChange={handleChangeNewComment}
											handleBeforeInput={handleBeforeInputNewComment}
											handlePastedText={handlePastedText}
										/>
										<button onClick={createComment}>Create Comment</button>
									</div>
								)}
							</div>
						</div>
					)}
				</div>
			</div>

			<div className='footer-sections'>
				{pageData.links && (
					<div className='comments'>
						<h3>Links</h3>
						{Object.values(pageData.links).map((c, i) => <p key={i + "link"}>{c.id}</p>)}
					</div>
				)}
				{pageData.referencedFrom && (
					<div className='comments'>
						<h3>References</h3>
						{Object.values(pageData.referencedFrom).map((c, i) =>
							Object.values(c).map((text, i2) => <p key={i + "ref"}>{text}</p>)
						)}
					</div>
				)}
			</div>
			{pageData.linkStart === undefined ? null : getLinkOptions()}
		</div>
	);

}